import { Rating, RatingScale } from './types';

class RatingHelper {
  static toReal(rating: number, scale: RatingScale = 10) {
    if (scale === 10) {
      return rating / 2;
    }

    return rating;
  }

  static toRounded(rating: number, nrOfDecimals = 1, scale: RatingScale = 10) {
    return parseFloat(RatingHelper.toReal(rating, scale).toFixed(nrOfDecimals));
  }

  static toRoundedString(
    rating: number,
    nrOfDecimals = 1,
    scale: RatingScale = 10
  ) {
    return RatingHelper.toReal(rating, scale).toFixed(nrOfDecimals);
  }

  static toHalf(rating: number, scale: RatingScale = 10) {
    return Math.ceil(RatingHelper.toRounded(rating, 1, scale) * 2) / 2;
  }

  static toWhole(rating: number, scale: RatingScale = 10) {
    return Math.round(RatingHelper.toHalf(rating, scale));
  }

  static convert(
    rating: number,
    nrOfDecimals = 1,
    scale: RatingScale = 10
  ): Rating {
    return {
      real: RatingHelper.toReal(rating, scale),
      rounded: RatingHelper.toRounded(rating, nrOfDecimals, scale),
      roundedString: RatingHelper.toRoundedString(rating, nrOfDecimals, scale),
      half: RatingHelper.toHalf(rating, scale),
      whole: RatingHelper.toWhole(rating, scale),
    };
  }
}

export default RatingHelper;
